import _ from 'lodash';

/**
 * The address fields that matter for comparison.
 * Excludes: search (autocomplete input), isInternational (UI toggle).
 */
const COMPARABLE_ADDRESS_FIELDS = ['street', 'suburb', 'state', 'postcode', 'country', 'place'];

/**
 * Normalizes an address object for comparison by:
 * - Picking only comparable fields (street, suburb, state, postcode, country, place)
 * - Converting null/undefined values to empty strings
 */
export function normalizeAddress(address: any): any {
  if (!address) {
    return {};
  }

  const result: any = {};

  for (const key of COMPARABLE_ADDRESS_FIELDS) {
    const val = _.get(address, key);
    result[key] = val === null || val === undefined ? '' : val;
  }

  return result;
}

/**
 * Compares two address objects for equality after normalization.
 * Only compares street, suburb, state, postcode, country, and place.
 * Treats null/undefined as equivalent to empty string.
 */
export function isEqualAddress(a: any, b: any): boolean {
  return _.isEqual(normalizeAddress(a), normalizeAddress(b));
}
